module.exports = __webpack_public_path__ + "static/media/folder-open-grey.e20755d7.svg";